import axios from 'axios';

let config = null;

export default {
  async fetch() {
    const response = await axios.get('/static/config.json');
    config = response.data;
  },
  get() {
    return config;
  },
};



// WEBPACK FOOTER //
// ./src/config.js